module.exports = __webpack_public_path__ + "media/assets/missing-file-img-thumb-1ca4f6dae359430d125a5d3a6acd8566.png";